type CSSOMString = string
type FontFaceLoadStatus = 'unloaded' | 'loading' | 'loaded' | 'error'
type FontFaceSetStatus = 'loading' | 'loaded'

interface FontFace {
	family: CSSOMString
	style: CSSOMString
	weight: CSSOMString
	stretch: CSSOMString
	unicodeRange: CSSOMString
	variant: CSSOMString
	featureSettings: CSSOMString
	variationSettings: CSSOMString
	display: CSSOMString
	readonly status: FontFaceLoadStatus
	readonly loaded: Promise<FontFace>
	load(): Promise<FontFace>
}

interface FontFaceSet {
	readonly status: FontFaceSetStatus
	readonly ready: Promise<FontFaceSet>
	check(font: string, text?: string): boolean
	load(font: string, text?: string): Promise<FontFace[]>
}

declare global {
	interface Document {
		fonts: FontFaceSet
	}
}

export default {
	state: {
		loaded: false,
	},
	mutations: {
		SET_LOADED(state, loaded: boolean) {
			state.loaded = loaded
		},
	},
	actions: {
		checkFont(context) {
			document.fonts.ready.then(() => {
				context.commit(
					'SET_LOADED',
					document.fonts.check('1em "Source Sans 3"'),
				)
			})

			context.dispatch('timeoutFont')
		},

		timeoutFont(context) {
			setTimeout(() => {
				if (!context.state.loaded) {
					context.commit('SET_LOADED', true)
					console.error(
						'After 10s timeout font Source Sans 3 was not yet loaded.',
					)
				}
			}, 10000)
		},
	},
}
